<template>
    <div class="data-container">
        <AttributesTable v-if="showAttributesTable" />
        <FeaturePopup />
        <FeaturePopupExpanded v-if="showFeaturePopupExpanded" />

        <GeoprocessingChart v-if="showGeoChart" :key="geoChartTimestamp" :chartData="geoChartData"
            :reportPayload="geoReportPayload" @close-chart="closeGeoChart" />
    </div>
</template>


<script>
import AttributesTable from './attributesTable/AttributesTable.vue';
import FeaturePopup from './select/FeaturePopup.vue';
import FeaturePopupExpanded from './select/FeaturePopupExpanded.vue';
import GeoprocessingChart from '@/components/mapTools/geoprocessings/GeoprocessingChart.vue';
import { selectService } from '@/services/map/selectService';

export default {
    name: 'DataContainer',
    components: {
        AttributesTable,
        FeaturePopup,
        FeaturePopupExpanded,
        GeoprocessingChart
    },
    computed: {
        showAttributesTable() {
            return this.$store.getters["attributeTable/isVisible"];
        },
        showFeaturePopupExpanded() {
            return selectService.state.maximized && selectService.state.features.length > 0;
        },
        showGeoChart() {
            // Check if geoprocessing tool has emitted results
            const tool = this.$store.getters.getMapTools['geoprocessing'];
            console.log("📊 DataContainer showGeoChart check:", tool);
            return tool && tool.action === 'showResults' && tool.data && tool.data.chartData;
        },
        geoChartData() {
            const tool = this.$store.getters.getMapTools['geoprocessing'];
            return (tool && tool.data) ? tool.data.chartData : {};
        },
        geoReportPayload() {
            const tool = this.$store.getters.getMapTools['geoprocessing'];
            return (tool && tool.data) ? tool.data.reportPayload : null;
        },
        geoChartTimestamp() {
            const tool = this.$store.getters.getMapTools['geoprocessing'];
            return (tool && tool.data) ? tool.data.timestamp : 0;
        }
    },
    // El store attributeTable es global: sin esto, al salir del mapa con la
    // tabla abierta y volver a entrar, la tabla reaparecía abierta.
    beforeDestroy() {
        this.$store.dispatch("attributeTable/closeTable");
    },
    methods: {
        closeGeoChart() {
            this.$store.dispatch('setMapToolAction', {
                tool: 'geoprocessing',
                action: 'cleanResults',
                data: {}
            });
        }
    }
}
</script>

.data-container {
position: absolute;
top: 0;
left: 0;
width: 100%;
height: 100%;
z-index: 5000;
pointer-events: none;
}

/* Re-enable pointer events for children */
.data-container > * {
pointer-events: auto;
}
